/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type arsenal_step = {
  id: string;
  size: number;
  step: arsenal_step.step;
};
export namespace arsenal_step {
  export enum step {
    PROJECT = 'Project',
    BOUGHT = 'Bought',
    UNASSEMBLED = 'Unassembled',
    ASSEMBLED = 'Assembled',
    PRIMED = 'Primed',
    PAINTED = 'Painted',
    BASED = 'Based',
  }
}
